export default {
  modulosAbrir: null,
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/central-mensagens/sessao-desktop.js